import EducationItem from "./EducationItem";

export default EducationItem;
